﻿import { showWarningNotification } from "../../Shared/Notifications/notifications";
import { isElement, isHTMLInputElement } from "../../Shared/typeGuards";

export const hubSpotForms = () => {
  const hubSpotForms = document.querySelectorAll("[data-hubspot-form]");
  
  hubSpotForms.forEach(form => formsObserver.observe(form, { childList: true, subtree: true }));
}

/**
 * Method that handles changes made to the form.
 * Add any handlers here.
 */
const mutationHandler = (mutationList: MutationRecord[]) => {
  mutationList.forEach(mutation => {
    if (mutation.type === "childList") {
      validateForIFrame(mutation);
      handleFileInput(mutation);
    }
  });
};

const formsObserver = new MutationObserver(mutationHandler);

const getFormFromTarget = (target: Element) => target.closest("[data-hubspot-form]");

/**
 * Shows a warning for editors if the embedded form uses an IFrame.
 */
const validateForIFrame = (mutation: MutationRecord) => {
  if (!isElement(mutation.target)) {
    return;
  }
  
  const form = getFormFromTarget(mutation.target);
  if (!form || !form.hasAttribute("data-validate-for-iframe")){
    return;
  }
  
  for (const addedNode of mutation.addedNodes) {
    // We only check for IFrames that are second degree descendants of the form, to not catch any other IFrames e.g. reCAPTCHA
    if (isElement(addedNode) && (addedNode.tagName === "IFRAME" && addedNode.parentNode?.parentNode === form || addedNode.querySelector(".hs-form-iframe"))) {
      showWarningNotification("Detected a HubSpot Form with an IFrame. RAW HTML should be used instead!");
    }
  }
};

/**
 * Handles file input added. Adds "Remove" button.
 */
const handleFileInput = (mutation: MutationRecord) => {
  const addedFileInputs = getFileInputs(mutation.addedNodes);
  addedFileInputs.forEach(fileInput => fileInput.addEventListener("change", () => fileInputOnChangeHandler(fileInput)))
};

const getFileInputs = (nodes: NodeList) => [...nodes]
  .filter<Element>(isElement)
  .flatMap(element => {
    if (element.tagName === "INPUT" && element.getAttribute("type") === "file") {
      return [element] as Element[];
    } else {
      return Array.from<Element>(element.querySelectorAll("input[type='file']"));
    }
  })
  .filter<HTMLInputElement>(isHTMLInputElement);

const removeButtonClass = "clear-attachments-button";

const fileInputOnChangeHandler = (fileInput: HTMLInputElement) => {
  if (fileInput.value !== "" && !fileInput.parentElement?.querySelector(`.${removeButtonClass}`)) {
    const removeAttachmentsButton = createRemoveAttachmentsButton(fileInput);
    if (removeAttachmentsButton) {
      fileInput.after(removeAttachmentsButton);
    }
  }
}

const createRemoveAttachmentsButton = (fileInput: HTMLInputElement) => {
  const parent = fileInput.parentElement;

  if (!parent) {
    return;
  }

  const removeAttachmentsButton = document.createElement("button");
  removeAttachmentsButton.classList.add(removeButtonClass);
  
  const icon = document.createElement("img");
  icon.src = "/ui/gfx/hubspotforms/cross.svg";
  removeAttachmentsButton.appendChild(icon);
  
  const text = document.createElement("span");
  text.textContent = "Remove";
  removeAttachmentsButton.appendChild(text);
  
  removeAttachmentsButton.addEventListener("click", () => {
    fileInput.value = "";

    parent!.removeChild(removeAttachmentsButton);
  });
  
  return removeAttachmentsButton;
}